import type { StepPageLocation, UrlMatcher } from './types';

/**
 * Matching de URL en CLIENTE (portado del backend `url-matcher.ts`). Lo usa el
 * motor composite para el targeting de página POR-PASO: como cada paso puede
 * apuntar a una página distinta (tours multi-página estilo Pendo), el SDK evalúa
 * la coincidencia en el navegador en cada navegación, no solo el backend.
 *
 * Errores de regex → `false` (no lanza): el patrón se validó al crear, pero una
 * fila corrupta no debe romper el render de una guía ajena.
 */
export function matchesUrl(matcher: UrlMatcher, pageUrl: string): boolean {
  switch (matcher.type) {
    case 'exact':
      return matcher.pattern === pageUrl;
    case 'prefix':
      return pageUrl.startsWith(matcher.pattern);
    case 'regex':
      try {
        return new RegExp(matcher.pattern).test(pageUrl);
      } catch {
        return false;
      }
  }
}

/** ¿El paso composite debe mostrarse en esta URL? Sitewide siempre; page → patrón. */
export function stepMatchesPage(
  loc: StepPageLocation | null | undefined,
  pageUrl: string,
): boolean {
  if (!loc || loc.scope === 'sitewide' || !loc.pattern) return true;
  return matchesUrl({ type: loc.matchType ?? 'prefix', pattern: loc.pattern }, pageUrl);
}
